/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { AuditSpotAuditSpotMediaDownloadQueryResponse, AuditSpotAuditSpotMediaDownloadPathParams, AuditSpotAuditSpotMediaDownloadQueryParams } from "../models/AuditSpotAuditSpotMediaDownload";

export function getAuditSpotAuditSpotMediaDownloadUrl(mediaId: AuditSpotAuditSpotMediaDownloadPathParams["mediaId"]) {
  const res = { method: 'GET', url: `/audit-spot/v1/media/${mediaId}/file` as const }
  return res
}

/**
 * @description Downloads audio file as attachment or partial content response
 * @summary Download media file
 * {@link /audit-spot/v1/media/:mediaId/file}
 */
export async function auditSpotAuditSpotMediaDownload(mediaId: AuditSpotAuditSpotMediaDownloadPathParams["mediaId"], params?: AuditSpotAuditSpotMediaDownloadQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<AuditSpotAuditSpotMediaDownloadQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getAuditSpotAuditSpotMediaDownloadUrl(mediaId).url.toString(), params, ... requestConfig })
  return res.data
}